import useGetter from "../useGetter";
import useDraftId from "./useDraftId";

export default function useDraftMessages() {
  const draftId = useDraftId();

  const { data: draftMessagesData, query: draftMessagesQuery } = useGetter(
    `/drafts/${draftId}/messages`,
    { enabled: !!draftId }
  );

  return { draftMessagesData, draftMessagesQuery };
}
